<template>
  <div class="login-onboarding">
    <section>
      <div class="container">
        <div class="bg-light px-3">
          <div class="row justify-content-center pt-5 form-style">
            <div class="col-lg-10">
              <div
                class="text-center d-flex justify-content-between align-items-center mb-4 pb-3"
              >
                <a v-on:click="handleBack" class="cursor-pointer">
                  <svg
                    width="12"
                    height="16"
                    viewBox="0 0 8 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.40059 10.7993L1.60059 5.99932L6.40059 1.19932"
                      stroke="#001D21"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </a>
                <h1 class="font-22 mb-0">Periodic Service Details</h1>
                <div>
                  <a
                    v-on:click="handleBack"
                    class="text-brand font-medium"
                    style="cursor: pointer"
                    >Skip</a
                  >
                </div>
              </div>

              <div class="d-lg-flex justify-content-between align-items-center mb-3">
                <h4 class="font-18 mb-lg-0">Cost Template</h4>
                <button
                  class="btn btn-primary"
                  v-on:click="exportCostFile()"
                  :disabled="exportFile && exportFile.status == 'INPROGRESS'"
                >
                  Generate File
                </button>
              </div>

              <div class="row justify-content-center mb-3">
                <div class="col-lg-6 mb-3">
                  <div class="border p-3 rounded mb-3">
                    <div
                      class="upload-btn-container"
                      v-if="(!importFile || importFile.status == 'SUCCESS') && !docFile"
                    >
                      <input
                        hidden
                        type="file"
                        id="job_card-upload"
                        accept=".xlsx,.xls"
                        @change="uploadDocument($event)"
                      />
                      <label htmlFor="tb-file-upload h-auto" for="preview-pan-0">
                        <div class="py-4 text-center">
                          <div class="mb-3">
                            <img
                              src="static/images/icon-file.svg"
                              width="20"
                              class="mx-auto"
                              alt=""
                            />
                          </div>
                          <div class="mb-3 text-secondary">Select document to upload</div>
                          <div>
                            <button class="btn btn-primary" v-on:click="uploadCostFile()">
                              Browse File
                            </button>
                          </div>
                        </div>
                      </label>
                      <span class="font-12 text-secondary"
                        >Supported files: .xlsx,.xls
                      </span>
                    </div>
                    <div v-else class="uploaded-photo text-center">
                      <svg
                        width="72"
                        height="75"
                        viewBox="0 0 72 75"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M70.5 7.0207H42V2.2082C41.9999 1.96708 41.9489 1.72909 41.8509 1.51194C41.7529 1.29478 41.6104 1.10404 41.434 0.953906C41.2576 0.803769 41.0518 0.698095 40.8319 0.644743C40.612 0.591391 40.3837 0.591733 40.164 0.645744L1.164 10.2707C0.833349 10.352 0.538228 10.5508 0.326819 10.8345C0.115409 11.1183 0.000199894 11.4704 0 11.8332L0 66.3749C0.000136302 66.758 0.128462 67.1284 0.361766 67.4191C0.59507 67.7098 0.917948 67.9016 1.272 67.9598L40.272 74.3765C40.4858 74.4122 40.7043 74.3979 40.9124 74.3346C41.1205 74.2713 41.3133 74.1606 41.4776 74.0099C41.6418 73.8593 41.7736 73.6723 41.8637 73.462C41.9539 73.2517 42.0004 73.0229 42 72.7915V67.979H70.5C70.8978 67.979 71.2794 67.81 71.5607 67.5092C71.842 67.2084 72 66.8003 72 66.3749V8.62487C72 8.19942 71.842 7.79139 71.5607 7.49055C71.2794 7.18971 70.8978 7.0207 70.5 7.0207ZM42 29.479H51V35.8957H42V29.479ZM12.228 49.483L18.735 38.3501C18.885 38.0955 18.9646 37.8008 18.9646 37.4999C18.9646 37.199 18.885 36.9042 18.735 36.6497L12.231 25.5167C12.1168 25.3383 12.0375 25.1371 11.9979 24.925C11.9582 24.713 11.9591 24.4946 12.0004 24.283C12.0417 24.0713 12.1226 23.8708 12.2382 23.6934C12.3538 23.516 12.5017 23.3654 12.6731 23.2507C12.8445 23.136 13.0358 23.0596 13.2355 23.026C13.4352 22.9923 13.6392 23.0022 13.8353 23.0551C14.0313 23.1079 14.2154 23.2026 14.3763 23.3334C14.5373 23.4642 14.6719 23.6285 14.772 23.8163L19.728 32.296C20.277 33.2328 21.723 33.2328 22.272 32.296L27.228 23.8163C27.3319 23.6371 27.4678 23.4816 27.6281 23.3587C27.7883 23.2358 27.9697 23.148 28.1618 23.1003C28.3538 23.0526 28.5528 23.046 28.7473 23.0808C28.9418 23.1155 29.1279 23.1911 29.295 23.303C29.4623 23.4144 29.6074 23.5599 29.7221 23.7313C29.8367 23.9027 29.9187 24.0966 29.9633 24.3019C30.0079 24.5072 30.0142 24.7199 29.9819 24.9278C29.9496 25.1357 29.8793 25.3347 29.775 25.5135L23.268 36.6465C23.118 36.901 23.0384 37.1958 23.0384 37.4967C23.0384 37.7976 23.118 38.0923 23.268 38.3469L29.772 49.4798C29.8764 49.6584 29.9469 49.8573 29.9794 50.0651C30.0119 50.2729 30.0059 50.4854 29.9616 50.6907C29.9173 50.896 29.8356 51.0899 29.7213 51.2614C29.6069 51.4329 29.462 51.5787 29.295 51.6903C28.9547 51.9048 28.5503 51.9711 28.1655 51.8756C27.7808 51.78 27.4451 51.5299 27.228 51.177L22.272 42.6974C22.1359 42.4683 21.9478 42.2797 21.7253 42.1492C21.5028 42.0186 21.253 41.9503 20.9992 41.9506C20.7454 41.951 20.4957 42.0199 20.2735 42.151C20.0513 42.2821 19.8636 42.4711 19.728 42.7006L14.772 51.1802C14.5544 51.5325 14.2187 51.7821 13.8342 51.8776C13.4496 51.9731 13.0455 51.9072 12.705 51.6935C12.538 51.5819 12.3931 51.4361 12.2787 51.2646C12.1644 51.0931 12.0827 50.8992 12.0384 50.6939C11.9941 50.4887 11.9881 50.2761 12.0206 50.0683C12.0531 49.8605 12.1236 49.6616 12.228 49.483ZM42 39.104H51V45.5207H42V39.104ZM54 39.104H69V45.5207H54V39.104ZM54 35.8957V29.479H69V35.8957H54ZM54 26.2707V19.854H69V26.2707H54ZM51 26.2707H42V19.854H51V26.2707ZM42 48.729H51V55.1457H42V48.729ZM54 48.729H69V55.1457H54V48.729ZM69 16.6457H54V10.229H69V16.6457ZM51 10.229V16.6457H42V10.229H51ZM42 58.354H51V64.7707H42V58.354ZM54 64.7707V58.354H69V64.7707H54Z"
                          fill="#628C9A"
                        />
                      </svg>
                      <div class="text-center" style="margin-top: 5px !important">
                        <p>{{ fileName }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="text-center">
                    <button
                      class="btn btn-primary mx-auto"
                      style="margin-right: 5px !important"
                      v-on:click="removeFile()"
                      v-if="docFile"
                    >
                      Remove
                    </button>
                    <button
                      class="btn btn-primary mx-auto"
                      id="save-button-cost"
                      v-on:click="importCostFile()"
                      :disabled="
                        (importFile && importFile.status == 'INPROGRESS') || !docFile
                      "
                    >
                      Upload
                    </button>
                  </div>
                </div>
              </div>
              <hr class="my-3" />
              <h4 class="font-18">History</h4>
              <div class="overflow-auto" style="max-height: 400px">
                <div class="card border rounded-3 mb-3" v-if="exportFile">
                  <div
                    class="card-body d-flex flex-row justify-content-between align-items-center"
                  >
                    <div>
                      <p class="font-14 mb-1">{{ exportFile.file_name }}</p>
                      <p
                        class="mb-0 text-warning font-medium"
                        v-if="exportFile.status == 'INPROGRESS'"
                      >
                        Generating File In Progress
                      </p>
                      <p
                        class="mb-0 text-success font-medium"
                        v-if="exportFile.status == 'SUCCESS'"
                      >
                        Successfully Generated
                      </p>
                      <p
                        class="mb-0 text-danger font-medium"
                        v-if="exportFile.status == 'FAILED'"
                      >
                        Uploading Failed
                      </p>
                    </div>
                    <div class="text-center" v-if="exportFile.status == 'INPROGRESS'">
                      <svg
                        width="26"
                        height="26"
                        viewBox="0 0 26 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="13"
                          cy="12.917"
                          r="11"
                          fill="#FAF9F8"
                          stroke="#D8DDE0"
                          stroke-width="2.5"
                        />
                        <path
                          d="M13 23.917C19.0751 23.917 24 18.9921 24 12.917C24 6.84186 19.0751 1.91699 13 1.91699"
                          stroke="#0E8090"
                          stroke-width="2.5"
                          stroke-linecap="round"
                        />
                      </svg>
                    </div>

                    <div class="text-center" v-if="exportFile.status == 'SUCCESS'">
                      <p class="mb-1 font-10 text-secondary">
                        {{ $helperService.dateFormateForOrder(exportFile?.created_at) }}
                      </p>
                      <a
                        href="javascript:void(0)"
                        v-on:click="getDownloadURL(exportFile.file)"
                      >
                        <svg
                          width="16"
                          height="18"
                          viewBox="0 0 16 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 11.6832L1 14.7714C1 15.2395 1.18437 15.6883 1.51256 16.0193C1.84075 16.3502 2.28587 16.5361 2.75 16.5361H13.25C13.7141 16.5361 14.1592 16.3502 14.4874 16.0193C14.8156 15.6883 15 15.2395 15 14.7714V11.6832M8.00098 1.46387V11.4639M8.00098 11.4639L12.001 7.64291M8.00098 11.4639L4.00098 7.64291"
                            stroke="#001D21"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </a>
                    </div>

                    <div class="text-center" v-if="exportFile.status == 'FAILED'"></div>
                  </div>
                </div>

                <div class="card border rounded-3" v-if="importFile">
                  <div class="card-body d-flex flex-row justify-content-between">
                    <div>
                      <p class="font-14 mb-1">{{ importFile.file_name }}</p>
                      <p
                        class="mb-0 text-warning font-medium"
                        v-if="importFile.status == 'INPROGRESS'"
                      >
                        Upload in progress
                      </p>
                      <p
                        class="mb-0 text-success font-medium"
                        v-if="importFile.status == 'SUCCESS'"
                      >
                        Successfully Uploaded
                      </p>
                      <p
                        class="mb-0 text-danger font-medium"
                        v-if="importFile.status == 'FAILED'"
                      >
                        Uploading Failed
                      </p>
                    </div>
                    <div class="text-center" v-if="importFile.status == 'INPROGRESS'">
                      <svg
                        width="26"
                        height="26"
                        viewBox="0 0 26 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="13"
                          cy="12.917"
                          r="11"
                          fill="#FAF9F8"
                          stroke="#D8DDE0"
                          stroke-width="2.5"
                        />
                        <path
                          d="M13 23.917C19.0751 23.917 24 18.9921 24 12.917C24 6.84186 19.0751 1.91699 13 1.91699"
                          stroke="#0E8090"
                          stroke-width="2.5"
                          stroke-linecap="round"
                        />
                      </svg>
                    </div>

                    <div class="text-center" v-if="importFile.status == 'SUCCESS'">
                      <p class="mb-1 font-10 text-secondary">
                        {{ $helperService.dateFormateForOrder(importFile?.created_at) }}
                      </p>
                      <a
                        href="javascript:void(0)"
                        v-on:click="downloadLogFile(importFile.id)"
                      >
                        <svg
                          width="16"
                          height="18"
                          viewBox="0 0 16 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 11.6832L1 14.7714C1 15.2395 1.18437 15.6883 1.51256 16.0193C1.84075 16.3502 2.28587 16.5361 2.75 16.5361H13.25C13.7141 16.5361 14.1592 16.3502 14.4874 16.0193C14.8156 15.6883 15 15.2395 15 14.7714V11.6832M8.00098 1.46387V11.4639M8.00098 11.4639L12.001 7.64291M8.00098 11.4639L4.00098 7.64291"
                            stroke="#001D21"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </a>
                    </div>

                    <div class="text-center" v-if="importFile.status == 'FAILED'">
                      <p class="mb-1 font-10 text-secondary">
                        {{ $helperService.dateFormateForOrder(exportFile?.created_at) }}
                      </p>
                      <a
                        href="javascript:void(0)"
                        v-on:click="downloadLogFile(importFile.id)"
                      >
                        <svg
                          width="16"
                          height="18"
                          viewBox="0 0 16 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 11.6832L1 14.7714C1 15.2395 1.18437 15.6883 1.51256 16.0193C1.84075 16.3502 2.28587 16.5361 2.75 16.5361H13.25C13.7141 16.5361 14.1592 16.3502 14.4874 16.0193C14.8156 15.6883 15 15.2395 15 14.7714V11.6832M8.00098 1.46387V11.4639M8.00098 11.4639L12.001 7.64291M8.00098 11.4639L4.00098 7.64291"
                            stroke="#001D21"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
                <template v-for="item in detailList" :key="item">
                  <div class="card border rounded-3" v-if="item">
                    <div
                      class="card-body d-flex flex-row justify-content-between align-items-center"
                    >
                      <div>
                        <p class="font-14 mb-1">{{ item.file_name }}</p>
                        <p
                          class="mb-0 text-warning font-medium"
                          v-if="item.status == 'INPROGRESS'"
                        >
                          Upload in progress
                        </p>
                        <p
                          class="mb-0 text-success font-medium"
                          v-if="item.status == 'SUCCESS'"
                        >
                          Successfully Uploaded
                        </p>
                        <p
                          class="mb-0 text-danger font-medium"
                          v-if="item.status == 'FAILED'"
                        >
                          Uploading Failed
                        </p>
                      </div>
                      <div class="text-center" v-if="item.status == 'INPROGRESS'">
                        <svg
                          width="26"
                          height="26"
                          viewBox="0 0 26 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="13"
                            cy="12.917"
                            r="11"
                            fill="#FAF9F8"
                            stroke="#D8DDE0"
                            stroke-width="2.5"
                          />
                          <path
                            d="M13 23.917C19.0751 23.917 24 18.9921 24 12.917C24 6.84186 19.0751 1.91699 13 1.91699"
                            stroke="#0E8090"
                            stroke-width="2.5"
                            stroke-linecap="round"
                          />
                        </svg>
                      </div>

                      <div class="text-center" v-if="item.status == 'SUCCESS'">
                        <p class="mb-1 font-10 text-secondary">
                          {{ $helperService.dateFormateForOrder(item?.created_at) }}
                        </p>
                        <a
                          href="javascript:void(0)"
                          v-on:click="downloadLogFile(item.id)"
                        >
                          <svg
                            width="16"
                            height="18"
                            viewBox="0 0 16 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 11.6832L1 14.7714C1 15.2395 1.18437 15.6883 1.51256 16.0193C1.84075 16.3502 2.28587 16.5361 2.75 16.5361H13.25C13.7141 16.5361 14.1592 16.3502 14.4874 16.0193C14.8156 15.6883 15 15.2395 15 14.7714V11.6832M8.00098 1.46387V11.4639M8.00098 11.4639L12.001 7.64291M8.00098 11.4639L4.00098 7.64291"
                              stroke="#001D21"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </a>
                      </div>

                      <div class="text-center" v-if="item.status == 'FAILED'">
                        <p class="mb-1 font-10 text-secondary">
                          {{ $helperService.dateFormateForOrder(exportFile?.created_at) }}
                        </p>
                        <a
                          href="javascript:void(0)"
                          v-on:click="downloadLogFile(item.id)"
                        >
                          <svg
                            width="16"
                            height="18"
                            viewBox="0 0 16 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 11.6832L1 14.7714C1 15.2395 1.18437 15.6883 1.51256 16.0193C1.84075 16.3502 2.28587 16.5361 2.75 16.5361H13.25C13.7141 16.5361 14.1592 16.3502 14.4874 16.0193C14.8156 15.6883 15 15.2395 15 14.7714V11.6832M8.00098 1.46387V11.4639M8.00098 11.4639L12.001 7.64291M8.00098 11.4639L4.00098 7.64291"
                              stroke="#001D21"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                </template>

                <template v-if="!exportFile && !importFile && detailList.length == 0">
                  <div class="card border rounded-3 mb-3">
                    <div class="card-body flex-row text-center">
                      <h1>No record found</h1>
                    </div>
                  </div>
                </template>
              </div>
              <div class="row mb-4 justify-content-center"></div>
              <div class="text-center my-4">
                <a v-on:click="handleBack" class="btn btn-primary px-5">Continue</a>
              </div>
            </div>
          </div>
        </div>
        <ErrorComponent ref="errorComponent" />
      </div>
    </section>
  </div>
</template>
<script>
import "./onboarding.scss";
import ErrorComponent from "@/components/ErrorComponent.vue";
export default {
  beforeUnmount() {
    if (this.statusCheckInterval) {
      clearInterval(this.statusCheckInterval);
    }
  },

  name: "ServiceDetails",

  components: {
    ErrorComponent,
  },

  data() {
    return {
      detailList: [],
      workshop_name: localStorage.getItem("workshop_name"),
      page_type: localStorage.getItem("page_type"),
      workshop_id: "",
      exportFile: {
        status: "",
      },
      importFile: {
        status: "",
      },
      statusCheckInterval: null,
      docFile: "",
      fileName: "",
    };
  },

  mounted() {
    if (this.page_type == "ADD_OUTLET") {
      this.workshop_id = localStorage.getItem("outlet_workshop_id");
    } else {
      this.workshop_id = localStorage.getItem("workshop_id");
    }
    if (this.workshop_id) {
      this.getDetailData();
    }

    // Set up interval to check status every 5 seconds
    this.statusCheckInterval = setInterval(() => {
      this.getDetailData();
    }, 5000);
  },

  methods: {
    handleBack() {
      this.$router.go(-1);
    },
    getDetailData() {
      this.$api
        .getAPI({
          _action: "workshop-export-cost/" + this.workshop_id,
        })
        .then((res) => {
          this.importFile = res.import;
          this.exportFile = res.export;
          this.detailList = res.import_list;
        })
        .catch(() => {});
    },
    downloadLogFile(id) {
      this.$api
        .getAPI({
          _action: "/download-workshop-cost/" + id,
          _hide_loader: true,
        })
        .then((res) => {
          if (res.path) {
            window.open(res.path);
          }
        })
        .catch(() => {});
    },
    exportCostFile() {
      this.$api
        .postAPI({
          _action: "export-cost/" + this.workshop_id,
        })
        .then(() => {})
        .catch(() => {});
      this.getDetailData();
    },
    importCostFile() {
      if (this.docFile) {
        this.$api
          .uploadImageAPI({
            _action: "/import-cost/" + this.workshop_id,
            _key: "file",
            _file: this.docFile,
          })
          .then(() => {});
        this.fileName = "";
        this.docFile = null;
        this.getDetailData();
      } else {
        this.$toast.open({
          type: "error",
          message: "Please select file.",
          duration: 3000,
          position: "top-right",
        });
      }
    },
    uploadDocument(event) {
      const file = event.target.files[0];
      if (file) {
        const validExtensions = ["xlsx", "xls"];
        const fileExtension = file.name.split(".").pop().toLowerCase();
        if (!validExtensions.includes(fileExtension)) {
          this.$toast.open({
            type: "error",
            message: "Please upload a valid Excel file (.xlsx or .xls).",
            duration: 3000,
            position: "top-right",
          });
          event.target.value = ""; // Reset the input
          return;
        }

        this.docFile = file;
        this.fileName = file.name;
      }
    },
    getDownloadURL(file) {
      if (file) {
        window.open(file);
      }
    },
    uploadCostFile() {
      const closebutton = document.getElementById("job_card-upload");
      closebutton.click();
    },
    removeFile() {
      this.docFile = null;
      this.fileName = null;
    },
  },
};
</script>

